import type { CreateEulaAgreementRequestDTO, LatestEulaResponseDTO } from 'declarations/dto/eula';

import { get, post } from './api';

export const getUsersLatestEulaAgreementStatus = async (id: string): Promise<boolean> => {
  const response = await get<boolean>(`/eula-user-agreements/user/${id}/latest-status`);

  return response.data;
};

export const getLatestEula = async (): Promise<LatestEulaResponseDTO> => {
  const response = await get<LatestEulaResponseDTO>('/eulas/latest');

  return response.data;
};

export const createNewEulaAgreement = async (
  request: CreateEulaAgreementRequestDTO
): Promise<void> => {
  const response = await post<void>('/eula-user-agreements', request);

  return response.data;
};
